<template>
  <div class="main">
    <div class="nav">
      <Nav :title="'套餐详情'" :fixed="true"></Nav>
      <div class="top"></div>
    </div>
    <div class="detail">
      <div class="detail_title">{{ name }}</div>
      <div
        class="detail_row"
        v-for="(item, index) in pelistdetail"
        :key="index"
        @click="showitemname(item)"
      >
        <div class="detail_row_title">组合名称</div>
        <div class="detail_row_text">{{ item.comboName }}</div>
      </div>
    </div>
    <div class="last_item"></div>
    <div class="pay_list_foot" v-if="showconfirm">
      <div class="pay_button" @click="peconfirm">选择</div>
    </div>
    <van-popup v-model="show" position="top" round
      ><div class="show_tite">项目名称</div>
      <div class="show_name">{{ show_name }}</div>
    </van-popup>
  </div>
</template>


<script>
import Nav from "../../components/nav.vue";
export default {
  components: {
    Nav,
  },
  data() {
    return {
      timer: null,
      showconfirm: false,
      show_name: "",
      show: false,
      name: "",
      pelistdetail: [],
      packageId: "",
    };
  },
  mounted() {
    this.getpelistdetail();
  },
  methods: {
    showitemname(item) {
      this.show_name = item.comboName;
      this.show = true;
    },
    async getpelistdetail() {
      try {
        if (this.$route.query.name) {
          this.name = this.$route.query.name;
          this.showconfirm = true;
        }
        this.packageId = this.$route.query.packageId;
        this.$showLoad();
        let url = "/peisprecontroller/packagetocombobypackageid";
        let R_data = {
          packageId: this.packageId,
        };
        await this.$axios_request.request_data(
          "nodeserver",
          url,
          "post",
          R_data,
          (data) => {
            console.log(data.data);
            this.pelistdetail = data.data.data.data;
            this.name = this.pelistdetail[0].packageName;
            this.$hideLoad();
          }
        );
      } catch (error) {
        this.isLoad = false;
        this.$hideLoad();
        this.$toast.fail("网络连接失败");
      }
    },
    async peconfirm() {
      try {
        this.$showLoad();
        let url = "/peisprecontroller/save";
        let R_data = {
          personalNo: this.$local.get("form").personalNo,
          name: this.$local.get("form").name,
          idcard: this.$local.get("form").idcard,
          gender: this.$local.get("form").genderId,
          birthday: this.$local.get("form").birthday,
          nation: this.$local.get("form").nation,
          marriage: this.$local.get("form").marriage,
          address: this.$local.get("form").address,
          phone: this.$local.get("form").phoneNumber,
          mobile: this.$local.get("form").phoneNumber,
          blood: this.$local.get("form").blood,
          thisAge: this.$local.get("form").thisAge,
          thisMonth: this.$local.get("form").thisMonth,
          checkupType: this.$local.get("form").TJLX,
          busiType: this.$local.get("form").petype,
          ordertime: this.$local.get("form").ordertime,
          packageId: this.packageId,
          recordDataStatus: "INSERT",
          combosList: JSON.stringify(this.pelistdetail),
        };
        await this.$axios_request.request_data(
          "nodeserver",
          url,
          "post",
          R_data,
          (data) => {
            console.log(data.data);
            console.log(data.data.data);
            if (data.data.data.data.state == "True") {
              this.$toast.success("预约成功");
              this.$local.remove("form");
              this.$local.remove("clientId");
              this.$local.remove("name");
              this.$local.remove("item");
              this.timer = setTimeout(() => {
                this.$hideLoad();
                this.$router.push({
                  path: "/pe_history_list",
                  query: {
                    clientId: this.clientId,
                  },
                });
              }, 2000);
            }
            this.$hideLoad();
          }
        );
      } catch (error) {
        console.log(error);
        this.isLoad = false;
        this.$hideLoad();
        this.$toast.fail("网络连接失败");
      }
    },
  },
  destroyed() {
    clearTimeout(this.timer);
  },
};
</script>

<style lang="scss" scoped>
.red {
  color: #e74c3c;
}
.textcolor {
  color: #5b8df6;
}
.main {
  margin: 0;
  padding: 0;
  .top {
    height: 50px;
  }
  .detail {
    display: flex;
    flex-direction: column;
    width: 93%;
    margin: 0px auto;
    margin-top: 8px;
    box-shadow: 0 1px 2px #aaaaaaaa;
    .detail_title {
      color: black;
      width: 90%;
      margin: 0px auto;
      text-align: center;
      margin-top: 8px;
    }
    .detail_row {
      display: flex;
      font-size: 16px;
      justify-content: space-between;
      margin: 0px 10px;
      line-height: 30px;
      .detail_row_title {
        color: #747d8c;
        width: 30%;
      }
      .detail_row_text {
        width: 50%;
        color: #747d8c;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
.pay_list_foot {
  width: 100%;
  background-color: white;
  position: fixed;
  bottom: 0;
  border-top: 1px solid #aaaaaaaa;
  height: 60px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  line-height: 70px;

  .pay_button {
    background-color: #5b8df6;
    margin-right: 20px;
    width: 95%;
    height: 40px;
    margin: 0px auto;
    line-height: 40px;
    border-radius: 5px;
    color: #ffffff;
  }
}
.show_tite {
  margin-top: 8px;
  font-size: 14px;
  text-align: center;
  line-height: 25px;
}
.show_name {
  font-size: 14px;
  text-align: center;
  line-height: 30px;
}
.van-popup {
  height: 78px;
}
.van-popup--top.van-popup--round {
  border-radius: 0 0 10px 10px;
}
.last_list {
  font-size: 15px;
  display: flex;
  flex-direction: row;
  margin-left: 10px;
  margin-right: 10px;
  justify-content: space-between;
  height: 35px;
  line-height: 30px;
  border-top: 1px solid red;
  .price {
    color: #5b8df6;
    // width: 40px;
    flex: 2;
    text-align: center;
  }
  .count {
    align-items: center;
    align-content: center;
    flex: 2;
    text-align: center;
  }
  .itemName {
    overflow: hidden;
    text-overflow: ellipsis;
    flex: 3;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    // width: 140px;
    //规定段落中的文本不进行换行
  }
  .project_c {
    text-align: center;
  }
}
</style>